import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  IconButton,
  Chip,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import GenericDialog from "../Dialog/GenericDialog";
import {
  makeDELETERequestOnUserServiceWithQueryParameter,
  makePUTRequestOnUserService,
  makeGETRequestOnUserService,
} from "../../Api/api";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DematDetailsInformationGrid from "./DematDetailsInformationGrid";
import documentPlaceHolderImage from "../../images/documentPlaceHolder.jpg";
import pdfPlaceHolderImage from "../../images/pdfPlaceHolder.jpg";
import GetAppIcon from "@mui/icons-material/GetApp";
import { downloadBase64 } from "../../Helpers/helpers";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import VerifiedIcon from '@mui/icons-material/Verified';
import InfoIcon from '@mui/icons-material/Info';

const NSDL_STATUS_LABEL: { [key: string]: string } = {
  "00": "Valid Record",
  "01": "DP ID does not match",
  "02": "Client ID does not match",
  "03": "DP ID, Client ID and PAN combination does not match",
  "04": "Account Status - Suspended",
  "05": "Account Status - Closed",
  "91": "Timeout",
};

const CDSL_STATUS_LABEL: { [key: string]: string } = {
  "01": "Valid BO-PAN",
  "02": "Invalid BOID",
  "04": "BOID is closed",
  "05": "PAN not matching with the First Holder",
  "06": "PAN not matching with the Second Holder",
  "07": "PAN not matching with the Third Holder",
  "08": "Frozen for Credit",
  "09": "Frozen for Debit",
  "10": "Frozen for Both Debit And Credit",
  "-1": "Failure",
};

export { NSDL_STATUS_LABEL, CDSL_STATUS_LABEL };

const toastr = require("toastr");

export default function KYCDematDetailsTab(props: any) {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedForDelete, setSelectedForDelete] = useState<string>("");
  const [currentlySelectedForEdit, setCurrentlySelectedForEdit] =
    useState<any>(null);
  const [showEditDematDetailsDialog, setShowEditDematDetailsDialog] =
    useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [verificationStatus, setVerificationStatus] = useState<{ [key: string]: any }>({});
  const [loadingStatus, setLoadingStatus] = useState<{ [key: string]: boolean }>({});

  const initialState = {
    dpType: "",
    dpName: "",
    clientId: "",
    dpID: "",
    oldClientId: "",
    accountStatus: "",
    panNumbers: ""
  };
  const [newDematDetails, setNewDematDetails] = React.useState(initialState);

  function deleteDematDetails(event: any) {
    event.preventDefault();

    makeDELETERequestOnUserServiceWithQueryParameter(
      `/kyc/demat_detail/delete/${props.currentUser.uuid}/${selectedForDelete}/`
    )
      .then((response) => {
        if (response?.status === 204) {
          toastr.success("Deleted demat details record !");
          setShowDeleteModal(!showDeleteModal);
          props.onDeleteDemat(selectedForDelete);
        }
      })
      .catch((error) => toastr.error(error));
  }

  function AddDematDetailsIcon() {
    return (
      <Grid item xs="auto">
        <AddCircleIcon
          color="primary"
          fontSize="large"
          id="add-circle-id"
          onClick={(event) => {
            setShowEditDematDetailsDialog(true);
          }}
          style={{ position: "fixed", top: 120, right: 50, zIndex: 1000 }}
        />
      </Grid>
    );
  }

  const handleSetDefault = (dematDetail: any) => {
    let payload = {
      user_id: props.currentUser.uuid,
      client_id: dematDetail.client_id,
      is_default: "True",
    };
    makePUTRequestOnUserService(
      "/kyc/demat_detail/update_default_demat_details/",
      payload
    )
      .then((response) => {
        if (response?.status === 200) {
          toastr.success(
            "Demat Account set as default! Pls close and click on eye icon again to view it set as default."
          );
        }
      })
      .catch((error) => toastr.error(error));
  };

  function DematDetailsList({ dematDetails }: any) {
    var details = null;
    if (
      typeof dematDetails === "object" &&
      !Array.isArray(dematDetails) &&
      dematDetails !== null
    ) {
      details = [dematDetails];
    } else {
      details = dematDetails;
    }
    const [expandedMap, setExpandedMap] = useState<{ [key: string]: boolean }>({});

    const handleClick = async (detail: any) => {
      const clientId = detail.client_id;
      setExpandedMap((prev) => ({
        ...prev,
        [clientId]: !prev[clientId],
      }));
      if (expandedMap[clientId]) {
        return;
      }
      if (!clientId || !detail?.dp_type) {
        toastr.error("Missing client ID or DP type");
        return;
      }
      setLoadingStatus((prev) => ({
        ...prev,
        [clientId]: true,
      }));
      let apiUrl = "";
      if (detail.dp_type === "NSDL") {
        apiUrl = `/kyc/nsdl_verification/${clientId}/`;
      } else if (detail.dp_type === "CDSL") {
        apiUrl = `/kyc/cdsl_verification/${clientId}/`;
      } else {
        console.warn("Unknown DP Type:", detail.dp_type);
        toastr.error("Unknown DP Type: " + detail.dp_type);
        setLoadingStatus((prev) => ({
          ...prev,
          [clientId]: false,
        }));
        return;
      }
      try {
        const response = await makeGETRequestOnUserService(apiUrl);
        if (response && response.status === 200) {
          let data = response.data;
          if (detail.dp_type === "NSDL" && data?.dan_response?.status) {
            data = {
              ...data,
              dan_response: {
                ...data.dan_response,
                status_label: NSDL_STATUS_LABEL[data.dan_response.status] || "Unknown Status",
              },
            };
          }
          if (detail.dp_type === "CDSL" && data?.dan_response?.statuscode) {
            data = {
              ...data,
              dan_response: {
                ...data.dan_response,
                status_label: CDSL_STATUS_LABEL[data.dan_response.statuscode] || "Unknown Status",
              },
            };
          }
          setVerificationStatus((prev) => ({ ...prev, [clientId]: data }));
          const danResponseStr = JSON.stringify(data.dan_response, null, 2);
          toastr.success(
            `Verification status fetched successfully: \n${danResponseStr}`,
            "",
            { escapeHtml: false }
          );
        }
      } catch (error: any) {
        console.error("API error:", error);
        const danResponse = error.response?.data?.dan_response;
        if (detail.dp_type === "NSDL" || detail.dp_type === "CDSL") {
          const danResponseStr = JSON.stringify(danResponse, null, 2);
          toastr.error(
            `Verification status fetched Failed: Status: \n${danResponseStr}`,
            "",
            { escapeHtml: false }
          );
        } else {
          toastr.error("Error fetching verification status: " + (error.message || "Unknown error"));
        }
        setExpandedMap((prev) => ({
          ...prev,
          [clientId]: false,
        }));
      } finally {
        setLoadingStatus((prev) => ({
          ...prev,
          [clientId]: false,
        }));
      }
    };

    return (
      <Grid container spacing={2}>
        {details.map((detail: any) => (
          <Grid item xs={12} sm={6} md={4} key={detail.id} sx={{ margin: 4 }}>
                 <Card sx={{ minWidth: 275, height: "100%" }}>
              <img
                src={
                  detail.image_filename?.toLowerCase().endsWith(".pdf")
                    ? pdfPlaceHolderImage
                    : detail.image
                      ? `data:image/png;base64,${detail.image}`
                      : documentPlaceHolderImage
                }
                alt="Demat Logo"
                style={{
                  width: "100%",
                  maxHeight: "150px",
                  objectFit: "cover",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center", width: "100%", mt: 1 }}>
                <Typography
                  sx={{ fontSize: 14, ml: 2 }}
                  color="text.primary"
                  gutterBottom
                >
                  Password - {detail.kyc_doc_plaintext_password || "NA"}
                </Typography>
                <Box sx={{ marginLeft: "auto", mr: 2 }}>
                  {["NSDL", "CDSL"].includes(detail.dp_type) ? (
                    (() => {
                      const dpType = detail.dp_type;
                      const statusCheck = dpType === "NSDL"
                        ? detail?.dan_status_check_response?.status || verificationStatus[detail.client_id]?.dan_response?.status
                        : detail?.dan_status_check_response?.statuscode || verificationStatus[detail.client_id]?.dan_response?.statuscode;
                      const statusLabel = dpType === "NSDL"
                        ? NSDL_STATUS_LABEL[statusCheck] || statusCheck
                        : CDSL_STATUS_LABEL[statusCheck] || statusCheck;
                      const isVerified = dpType === "NSDL" ? statusCheck === "00" : statusCheck === "01";
                      if (statusCheck) {
                        return (
                          <Tooltip
                            title={`Status: ${statusLabel}`}
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: '1rem',
                                  padding: '6px 12px',
                                },
                              },
                            }}
                          >
                            {isVerified ? (
                              <VerifiedIcon sx={{ color: "green", fontSize: 28 }} />
                            ) : (
                              <InfoIcon sx={{ color: "orange", fontSize: 28 }} />
                            )}
                          </Tooltip>
                        );
                      } else {
                        return (
                          <Tooltip
                            title="Check the status to click"
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: '1rem',
                                  padding: '6px 12px',
                                },
                              },
                            }}
                          >
                            <IconButton
                              onClick={() => handleClick(detail)}
                              disabled={loadingStatus[detail.client_id]}
                            >
                              {loadingStatus[detail.client_id] ? (
                                <CircularProgress size={30} />
                              ) : (
                                <InfoOutlinedIcon sx={{ fontSize: 28 }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        );
                      }
                    })()
                  ) : (
                    <pre>{JSON.stringify(verificationStatus[detail.client_id], null, 2)}</pre>
                  )}
                </Box>
              </Box>
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="text.secondary"
                  gutterBottom
                >
                  {detail.dp_type || "-"} - ({detail.account_status || "UNKNOWN"} Account)
                </Typography>
                <Typography variant="h5" component="div">
                  {detail.dp_name || "-"}
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                  {detail.client_id || "-"}
                </Typography>
                <Typography variant="body2">{detail.dp_id || "-"}</Typography>
              </CardContent>
              <CardActions>
                <IconButton
                  aria-label="edit"
                  onClick={(event) => {
                    setCurrentlySelectedForEdit(detail);
                    setEditMode(true);

                    setShowEditDematDetailsDialog(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  aria-label="download"
                  onClick={() =>
                    downloadBase64(detail.image, detail?.image_filename)
                  }
                >
                  <GetAppIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  onClick={(event) => {
                    setShowDeleteModal(!showDeleteModal);
                    setSelectedForDelete(detail.client_id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
                <Chip
                  label={detail.is_default ? "Default" : "Set Default"}
                  color="success"
                  variant={detail.is_default ? "filled" : "outlined"}
                  {...(!detail.is_default && {
                    onClick: () => handleSetDefault(detail),
                  })}
                />
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (props?.dematDetails) {
    return (
      <Grid style={{ margin: "20px 0", padding: "0 20px" }}>
        <Grid container alignItems="center" spacing={3}>
          <Grid item xs="auto">
            <AddDematDetailsIcon />
          </Grid>

          <DematDetailsList dematDetails={props?.dematDetails} />
        </Grid>
        {showDeleteModal ? (
          <GenericDialog
            show={showDeleteModal}
            heading="Delete Demat Details"
            inputProps="Are you sure you want to delete this demat details record?"
            onClose={(event: any) => {
              event.preventDefault();
              setShowDeleteModal(!showDeleteModal);
            }}
            handleSubmit={(event: any) => {
              event.preventDefault();
              deleteDematDetails(event);
            }}
          />
        ) : (
          ""
        )}

        {showEditDematDetailsDialog && (
          <GenericDialog
            fullWidth={true}
            show={showEditDematDetailsDialog}
            heading={editMode ? "Update Demat Details" : "Create Demat Details"}
            inputProps={
              <DematDetailsInformationGrid
                dematDetails={
                  editMode ? currentlySelectedForEdit : newDematDetails
                }
                saveDematDetails={props.saveDematDetails}
                addDematDetails={props.addDematDetails}
                currentUser={props.currentUser}
              />
            }
            showSubmitButton={false}
            onClose={(event: any) => {
              event.preventDefault();
              setShowEditDematDetailsDialog(!showEditDematDetailsDialog);
              if (editMode) {
                setEditMode(false);
              }
            }}
            handleSubmit={(event: any) => {
              event.preventDefault();
              setShowEditDematDetailsDialog(!showEditDematDetailsDialog);
              if (editMode) {
                setEditMode(false);
              }
            }}
          />
        )}
      </Grid>
    );
  } else {
    return (
      <Grid style={{ margin: "20px 0", padding: "0 20px" }}>
        <Grid container alignItems="center" spacing={3}>
          <AddDematDetailsIcon />
        </Grid>
        {showEditDematDetailsDialog && (
          <GenericDialog
            fullWidth={true}
            show={showEditDematDetailsDialog}
            heading={editMode ? "Update Demat Details" : "Create Demat Details"}
            inputProps={
              <DematDetailsInformationGrid
                dematDetails={
                  editMode ? currentlySelectedForEdit : newDematDetails
                }
                saveDematDetails={props.saveDematDetails}
                addDematDetails={props.addDematDetails}
              />
            }
            showSubmitButton={false}
            onClose={(event: any) => {
              event.preventDefault();
              setShowEditDematDetailsDialog(!showEditDematDetailsDialog);
              if (editMode) {
                setEditMode(false);
              }
            }}
            handleSubmit={(event: any) => {
              event.preventDefault();
              setShowEditDematDetailsDialog(!showEditDematDetailsDialog);
              if (editMode) {
                setEditMode(false);
              }
            }}
          />
        )}
      </Grid>
    );
  }
}